"use client";

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledEditorWrapper = styled(Box)`
  .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content {
    border: none !important;
  }

  .ck-editor__editable_inline {
    min-height: 148px !important;
    height: 100% !important;
    max-height: 300px !important;
    font-size: 16px;
    line-height: 1.6;
    background-color: transparent !important;
    padding: 0px 24px;
    color: #000000 !important;
    border: 1px solid #e5e7eb !important;
  }

  .ck.ck-toolbar {
    background-color: transparent !important;
    border: 1px solid #e5e7eb !important;
    padding: 6px 12px !important;
    border-bottom: none !important;
  }

  .ck.ck-list {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }

  .ck-rounded-corners .ck.ck-dropdown > .ck-dropdown__panel > .ck-list .ck-list__item > .ck-button {
    background-color: #f7f7f7 !important;
  }

  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
    background-color: #f7f7f7 !important;
    border: none !important;
  }

  .ck.ck-toolbar .ck-button {
    background-color: transparent !important;
    border: 1px solid #e5e7eb; /* Nút trong toolbar có màu nền khác */
    color: #9e9e9e !important;
  }

  .ck.ck-toolbar .ck-button:hover {
    background-color: #0000000a !important;
  }
`;
